import type { PropType } from 'vue'
import type {
  DataTableAction,
  DataTableHeader,
  DataTableItem,
  DataTablePagination,
} from './types'

export default {
  actions: {
    type: Array as PropType<DataTableAction[]>,
    default: () => [],
  },
  allowSelection: {
    required: false,
    type: Boolean,
    default: false,
  },
  headers: {
    type: Array as PropType<DataTableHeader[]>,
    default: () => [],
  },
  hideHeader: {
    required: false,
    type: Boolean,
    default: false,
  },
  hideLabelActionsBreakpoint: {
    type: Number,
    default: null,
  },
  isLoading: {
    required: false,
    type: Boolean,
    default: false,
  },
  keepSelectedOnChange: {
    type: Boolean,
    default: false,
  },
  items: {
    type: Array as PropType<DataTableItem[]>,
    default: () => [],
  },
  selectedItems: {
    type: Array,
    default: () => [],
  },
  striped: {
    required: false,
    type: Boolean,
    default: false,
  },
  stickyMenu: {
    required: false,
    type: Boolean,
    default: false,
  },
  hideActionsMenu: {
    type: Boolean,
    default: false,
  },
  isSortIconAlwaysVisible: {
    type: Boolean,
    default: false,
  },
  pagination: {
    type: Object as PropType<DataTablePagination>,
    default: null,
  },
}
